import { render, staticRenderFns } from "./indexCenter.vue?vue&type=template&id=4fd6c9d6&scoped=true&"
import script from "./indexCenter.vue?vue&type=script&lang=js&"
export * from "./indexCenter.vue?vue&type=script&lang=js&"
import style0 from "./indexCenter.vue?vue&type=style&index=0&id=4fd6c9d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd6c9d6",
  null
  
)

export default component.exports